import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiService } from 'src/app/shared/services/api.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatTableModule } from '@angular/material/table';


@Component({
  selector: 'app-process-results',
  standalone: true,
  imports: [
    MatTableModule,
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './process-results.component.html',
  styleUrls: ['./process-results.component.scss']
})
export class ProcessResultsComponent implements OnInit {
  summaryList: any[] = [];
  processedResults: any[] = [];
  displayedColumns: string[] = [
    'register_no',
    'sgpa',
    'cgpa',
    'overall_raw_total',
    'overall_processed_total',
    'total_percentage',
    'overall_result',
    'grade_sub1',
    'grade_sub2',
    'grade_sub3',
    'grade_sub4',
    'grade_sub5',
    'grade_sub6'
  ];

  form: FormGroup;
  courseList: any[] = [];
  isLoading = false;
  semesterList: any[] = [];
  years: any;
  months: any;
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private common: CommonService,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      course_id: [null, Validators.required],
      semester_number: [null, Validators.required],
      exam_month: ['', Validators.required],
      exam_year: ['', Validators.required],
      result_type: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.api.get('courses/list').subscribe(res => {
      if (res.success) this.courseList = res.data;
    });

    this.api.get('semesters/list').subscribe(res => {
      if (res.success) this.semesterList = res.data;
    });
    this.year_list()
    this.month_list();
  }


  processResults() {
    this.isLoading = true;

    this.api.post('results/process', this.form.value).subscribe({
      next: (res: any) => {
        this.processedResults = res.data || [];
        this.isLoading = false;
        this.loadSummary();
      },
      error: (err) => {
        console.error('Error processing results', err);
        this.isLoading = false;
      }
    });
  }

  year_list() {
    this.api.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.years = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.api.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  loadSummary(): void {
    const course_id = this.form.get('course_id')?.value;
    if (!course_id) return;

    this.api.get(`results/processed/summary?course_id=${course_id}`).subscribe((res: any) => {
      if (res.success) this.summaryList = res.data;
    });
  }
}
